import { useCompanyMetadataSafe } from "src/context/Company/Metadata/useCompanyMetadata";
import { EntityScoresProviderProps } from "../provider";

export const useOverridenVariationsIds = (entity: EntityScoresProviderProps["entity"]): number[] | undefined => {
    const companyMetadata = useCompanyMetadataSafe();

    if (entity === "company" && companyMetadata) {
        const { company } = companyMetadata;
        return company.organizationSector?.variationIds;
    }

    return undefined;
};
